var React = require("react");
var Radium = require("radium");

var Sign = require("./Sign.jsx");
var Checkbox = require("../Checkbox/Checkbox.jsx");

var boxStyle = {
	borderRadius: '100%'
};

module.exports = Radium(
	React.createClass({

		render: function() {
			return (
				<Checkbox {...this.props} Sign={Sign} customBoxStyle={boxStyle} />
			);
		}

	})
);


// WEBPACK FOOTER //
// ./src/components/RadioGroup/Radio.jsx